import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';

const Privacy = () => {
    const { t } = useTranslation();

    return (
        <div className="page-wrapper">
            <header className="header header-fixed">
                <div className="container">
                    <div className="header-content">
                        <div className="left-content">
                            <Link to="/welcome" className="back-btn">
                                <ChevronLeft className="icon" />
                            </Link>
                            <h6 className="title">{t('privacy.title')}</h6>
                        </div>
                    </div>
                </div>
            </header>

            <div className="page-content">
                <div className="container">
                    <div className="content-body">
                        <div className="privacy-content">
                            <h2>{t('privacy.title')}</h2>
                            
                            <section>
                                <h3>{t('privacy.sections.dataCollection.title')}</h3>
                                <p>{t('privacy.sections.dataCollection.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.dataUse.title')}</h3>
                                <p>{t('privacy.sections.dataUse.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.dataSecurity.title')}</h3>
                                <p>{t('privacy.sections.dataSecurity.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.dataSharing.title')}</h3>
                                <p>{t('privacy.sections.dataSharing.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.cookies.title')}</h3>
                                <p>{t('privacy.sections.cookies.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.userRights.title')}</h3>
                                <p>{t('privacy.sections.userRights.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.dataRetention.title')}</h3>
                                <p>{t('privacy.sections.dataRetention.content')}</p>
                            </section>

                            <section>
                                <h3>{t('privacy.sections.contact.title')}</h3>
                                <p>{t('privacy.sections.contact.content')}</p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
